/* eslint no-undef: 0 */  // --> OFF
/* eslint no-unused-vars: 0 */
/// the 'new' in document ready.
$(function() {
  console.log('newslanding');
  let clicktrig = $('.news-open-trigger');

  let clickpanes = $('.news-sidebar-pane');
  clickpanes.on('click', function() {
    console.log('clicpane');
    $(this).next().slideToggle();
    $(this).find('.news-open-trigger').toggleClass('is-active');
  });
});



// WEBPACK FOOTER //
// ./scripts/newslanding.js